import { Box, Grid, Typography } from '@mui/material';
import { KeyValue } from './contributor';
import React from 'react';
import { Gridstyles } from './index';
import { NomineeType } from '../../redux-store/types/api-types';
import { formatShortDate } from '../../utils/date';
import { Notes, SubHeading } from '../investors/components';
import { isMinor } from '../../utils/utilityFunctions';

export default function NomineeDetails({
  nominees = [],
}: {
  nominees: Partial<NomineeType>[];
}): JSX.Element {
  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}
        mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Typography
              component="h2"
              sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
              Nominee Details
            </Typography>
            {nominees.length === 0 ? (
              <>
                <Grid
                  xs={12}
                  sm={12}
                  sx={{
                    fontSize: 18,
                    fontWeight: 600,
                    color: 'common.black',
                    textAlign: 'center',
                    my: 3,
                  }}>
                  No Nominees
                </Grid>
                <Notes
                  displayContent={
                    'I / We hereby confirm that I / We do not wish to appoint any nominee(s) for my units of retail fund held in my / our folio / demat account and understand the issues involved in non-appointment of nominee(s) and further are aware that in case of death of all the account holder(s), my / our legal heirs would need to submit all the requisite documents for claiming of assets held in my / our folio/ demat account which may also include documents issued by Court or other such competent authority, based on the value of assets held in the folio'
                  }
                />
              </>
            ) : (
              nominees.map((nominee, index: number) => {
                const title = [
                  'First Nominee Details',
                  'Second Nominee Details',
                  'Third Nominee Details',
                ][index];
                return (
                  <React.Fragment key={nominee.id}>
                    <SubHeading sx={{ color: 'common.black', letterSpacing: 0.5 + 'px' }}>
                      {title}
                    </SubHeading>
                    <Gridstyles>
                      <Grid
                        item
                        container
                        pt={2}
                        pb={5}
                        rowSpacing={6}
                        columnSpacing={13}
                        direction="row"
                        justifyContent="space-between"
                        alignItems="flex-start">
                        <KeyValue
                          title={`Nominee Name (Please mention nominee name as per Tax Id proof) - ${
                            index + 1
                          }`}
                          description={nominee.nomineeName}
                        />
                        <KeyValue
                          title={'Nominee Relationship with the Security Holder'}
                          description={nominee.nomineeRelationship}
                        />
                        <KeyValue
                          title={'Nominee Percentage'}
                          description={nominee.nomineePercentage}
                        />
                        <KeyValue
                          title={'Nominee Country Tax Identification Number'}
                          description={nominee.taxIdNumber}
                        />
                        <KeyValue
                          title={'Nominee Date Of Birth'}
                          description={formatShortDate(nominee.dateOfBirth)}
                        />

                        {nominee.dateOfBirth && isMinor(nominee.dateOfBirth) && (
                          <>
                            {/* <KeyValue
                              title={'Date of Attaining Majority'}
                              description={formatShortDate(nominee.dateOfAttainingMajority)}
                            /> */}
                            <KeyValue title={'Guardian Name'} description={nominee.guardianName} />
                            <KeyValue
                              title={'Guardian Address'}
                              description={nominee.guardianAddress}
                            />
                            <KeyValue
                              title={'Guardian Country Tax Identification Number'}
                              description={nominee.guardianTaxIdNumber}
                            />
                          </>
                        )}
                      </Grid>
                    </Gridstyles>
                  </React.Fragment>
                );
              })
            )}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
